<template>
  <v-dialog
    v-model="dialog"
    class="ch-dialog"
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-h-square fa-fw"></i>
          <span class="title">NEW HOTEL</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">NAME *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="name"
                    :rules="nameRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">ADDRESS *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="address"
                    :rules="addressRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">TIMEZONE *</div>
                <div class="form-input">
                  <v-select
                    :items="timezoneItems"
                    v-model="timezone"
                    @focus.native="getTimezoneList"
                    @click.native="getTimezoneList"
                    full-width
                    bottom
                    single-line
                    autocomplete
                    :rules="timezoneRules"
                    content-class="create-autocomplete-select"
                  ></v-select>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">DESCRIPTION</div>
                <div class="form-input">
                  <v-text-field
                    v-model="desc"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">CHECKIN *</div>
                <div class="form-input">
                  <v-layout row>
                    <v-flex xs6>
                      <v-select
                        :items="hourItems"
                        v-model="checkin_hour"
                        :rules="checkinHourRules"
                        full-width
                        single-line
                        content-class="create-select"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        :items="minuteItems"
                        v-model="checkin_minute"
                        :rules="checkinMinuteRules"
                        full-width
                        single-line
                        content-class="create-select"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">CHECKOUT *</div>
                <div class="form-input">
                  <v-layout row>
                    <v-flex xs6>
                      <v-select
                        :items="hourItems"
                        v-model="checkout_hour"
                        :rules="checkoutHourRules"
                        full-width
                        single-line
                        content-class="create-select"
                      ></v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        :items="minuteItems"
                        v-model="checkout_minute"
                        :rules="checkoutMinuteRules"
                        full-width
                        single-line
                        content-class="create-select"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <div class="form-group" v-if="visibleTag">
                <div class="form-title">TAG</div>
                <div class="form-input">
                  <v-text-field
                    v-model="tag"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group" v-if="visibleType">
                <div class="form-title">TYPE</div>
                <div class="form-input">
                  <v-select
                    :items="typeItems"
                    v-model="type"
                    full-width
                    single-line
                    content-class="create-select"
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-checkbox-group">
                <div class="form-title">PERMISSION</div>
                <div class="form-checkbox">
                  <div
                    class="checkbox-wrapper"
                    v-for="(permissionItem, index) in permissionItems"
                    :key="permissionItem.id"
                  >
                    <v-checkbox :label="getRoleString(permissionItem.role)" v-model="permissions[index]" :value="permissionItem.id"></v-checkbox>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createHotel"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
        <!-- <v-btn
          color="error"
          @click.native="clearAllField"
        >
          <v-icon class="mr-2">clear_all</v-icon>
          Clear All
        </v-btn> -->
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import momentTimezone from 'moment-timezone';
  import { hotelsEventBus } from '@/components/admin/hotels/hotelsEventBus';
  import api from '../../../api';
  import PermissionModel from '../../../permissions';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        name: null,
        address: null,
        permissionItems: [],
        permissions: [],
        timezone: null,
        timezoneItems: [],
        desc: null,
        hourItems: [],
        minuteItems: [],
        checkin_hour: 15,
        checkin_minute: 0,
        checkout_hour: 12,
        checkout_minute: 59,
        tag: '',
        type: '',
        visibleType: false,
        visibleTag: false,
        typeItems: ['public', 'private'],
        nameRules: [
          v => (v === 0) || !!v || 'Please input Name',
        ],
        addressRules: [
          v => (v === 0) || !!v || 'Please input Address',
        ],
        timezoneRules: [
          v => (v === 0) || !!v || 'Please input Timezone',
        ],
        checkinHourRules: [
          v => (v === 0) || !!v || 'Please select',
        ],
        checkinMinuteRules: [
          v => (v === 0) || !!v || 'Please select',
        ],
        checkoutHourRules: [
          v => (v === 0) || !!v || 'Please select',
        ],
        checkoutMinuteRules: [
          v => (v === 0) || !!v || 'Please select',
        ],
        // NOTE: dialog
        createDialog: false,
      };
    },
    methods: {
      /**
       * @description hour 배열 생성
       * @returns { Array } hours
       */
      setHour() {
        const hours = [];
        for (let index = 0; index < 24; index += 1) {
          hours.push({
            text: index.toString(),
            value: index,
          });
        }
        return hours;
      },
      /**
       * @description minute 배열 생성
       * @returns { Array } minutes
       */
      setMimute() {
        const minutes = [];
        for (let index = 0; index < 60; index += 1) {
          minutes.push({
            text: index.toString(),
            value: index,
          });
        }
        return minutes;
      },
      getPermission() {
        api.getPermission()
        .then((result) => {
          if (result.status === 200) {
            this.permissionItems = result.data.filter(r => r.type === 'igrms' || r.type === 'staffapp');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 선택된 checkbox의 아이디값을 새 배열로 반환
       * @returns { Array } permissions
       */
      getPermissions() {
        return this.permissions.filter(item => (item !== undefined) && (item !== null) && item !== '');
      },
      /**
       * @description all timezone list
       * @returns { Array }
       */
      getTimezoneList() {
        this.timezoneItems = momentTimezone.tz.names();
      },
      /**
       * @description 호텔생성화면, valid가 false이면 작동안됨
       * @todo getTimezoneList 제대로 동작하지 않음
       */
      createHotel() {
        // this.timezoneItems = this.getTimezoneList();
        const params = {
          name: this.name,
          address: this.address,
          timezone: this.timezone,
          desc: this.desc,
          checkin_hour: this.checkin_hour,
          checkin_minute: this.checkin_minute,
          checkout_hour: this.checkout_hour,
          checkout_minute: this.checkout_minute,
          tag: this.tag,
          type: this.type,
        };
        api.createHotel(params)
        .then((result) => {
          if (result.status === 200) {
            const hotelId = result.data.id;                        // hotel id
            api.updateHotelPermission(hotelId, this.getPermissions())
            .then((result2) => {
              if (result2.status === 200) {
                this.alert.type = 'check_circle';
                this.alert.color = 'green';
                this.alert.message = 'Success Create';
                this.alertOccur();
                hotelsEventBus.$emit('reloadList');
                this.closeDialog();
              }
            })
            .catch((err) => {
              this.alert.type = 'error';
              this.alert.color = 'red';
              this.alert.message = err.response.data.message;
              this.alertOccur();
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      clearAllField() {
        this.$refs.form.reset();
        this.checkin_hour = 15;
        this.checkin_minute = 0;
        this.checkout_hour = 12;
        this.checkout_minute = 59;
      },
      openCreateDialog() {
        this.createDialog = true;
        this.getPermission();
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
      getRoleString(role) {
        return PermissionModel.getRoleString(role);
      },
    },
    mounted() {
      const vm = this;
      this.hourItems = this.setHour();
      this.minuteItems = this.setMimute();
      hotelsEventBus.$on('openDialog', () => {
        this.dialog = true;
        this.$nextTick(() => {
          vm.getPermission();
        });
      });
    },
    created() {
      if (localStorage.getItem('domain_type') === 'root') {
        this.visibleType = true;
        this.visibleTag = true;
      }
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/hotels/CreateHotel.vue